import React, { useState, useEffect } from 'react';
import vr from '../../../../utils/Verifiers';
import './rpt_ejecucion_trasplante.css'
import TablaEjecucionSemana from './TablaEjecucionSemana';
import TablaEjecucionBloque from './TablaEjecucionBloque';

const Rpt_ejecucion_trasplante = () => {
    const [selecciones, setselecciones] = useState({ semana_inicio: '', semana_fin: '', flor_id: '', variedad_id: '', color_id: '', rancho: "", valvula: "" });
    const [reporte, setreporte] = useState([]);
    const [listas, setlistas] = useState({
        semanas: [],
        flores: [],
        variedades: [],
        colores: [],
        ranchos: [],
        valvulas: []
    });
    const [visor, setvisor] = useState({ tipo_visualizacion: 'semana' });

    useEffect(() => {
        getReporte();
    }, []);

    const getReporte = async (selec = { ...selecciones }) => {
        const resp = await vr.getDataAPI('reportes/trasplante/ejecucion', selec);
        if (!resp || !resp.estatus) {
            setselecciones(selec);
            return;
        }
        console.log(resp);
        selec.semana_inicio = resp.data.semana_inicio;
        selec.semana_fin = resp.data.semana_fin;
        setselecciones(selec);
        setreporte(resp.data.reporte);
        setlistas({
            semanas: !resp.data.semanas.includes(selec.semana_inicio) ? [selec.semana_inicio, ...resp.data.semanas] : resp.data.semanas || [],
            flores: resp.data.flores || [],
            variedades: resp.data.variedades || [],
            colores: resp.data.colores || [],
            ranchos: resp.data.ranchos || [],
            valvulas: resp.data.valvulas || []
        });
    }

    const changeValue = (e) => {
        const { name, value } = e.target;
        getReporte({ ...selecciones, [name]: value });
    }

    const ajusteVisor = (atributo, valor) => {
        setvisor({ ...visor, [atributo]: valor });
    }

    return (
        <div className='col-lg-12 m-0 p-0 dosis' style={{ height: "calc( 100vh - 60px)" }}>
            <div className='grid-selectores p-2'>
                <div className='form-group'>
                    <label className='text-bold'>Semana inicio</label>
                    <select className='form-control' name="semana_inicio" value={selecciones.semana_inicio} onChange={changeValue}>
                        {listas.semanas.map((semana) => (
                            <option key={semana + "i"} value={semana}>{semana}</option>
                        ))}
                    </select>
                </div>
                <div className='form-group'>
                    <label className='text-bold'>Semana fin</label>
                    <select className='form-control' name="semana_fin" value={selecciones.semana_fin} onChange={changeValue}>
                        {listas.semanas.map((semana) => (
                            <option key={semana + "f"} value={semana}>{semana}</option>
                        ))}
                    </select>
                </div>
                <div className='form-group'>
                    <label className='text-bold'>Flor</label>
                    <select className='form-control' name="flor_id" value={selecciones.flor_id} onChange={changeValue}>
                        <option value="">Todas las flores</option>
                        {listas.flores.map((flor) => (
                            <option key={flor.id + "flor"} value={flor.id}>{flor.nombre}</option>
                        ))}
                    </select>
                </div>
                <div className='form-group'>
                    <label className='text-bold'>Variedad</label>
                    <select className='form-control' name="variedad_id" value={selecciones.variedad_id} onChange={changeValue}>
                        <option value="">Todas las variedades</option>
                        {listas.variedades.map((variedad) => (
                            <option key={variedad.id + "variedad"} value={variedad.id}>{variedad.nombre}</option>
                        ))}
                    </select>
                </div>
                <div className='form-group'>
                    <label className='text-bold'>Color</label>
                    <select className='form-control' name="color_id" value={selecciones.color_id} onChange={changeValue}>
                        <option value="">Todas los colores</option>
                        {listas.colores.map((color) => (
                            <option key={color.id + "color"} value={color.id}>{color.nombre}</option>
                        ))}
                    </select>
                </div>
                <div className='form-group'>
                    <label className='text-bold'>Rancho</label>
                    <select className='form-control' name="rancho_id" value={selecciones.rancho_id} onChange={changeValue}>
                        <option value="">Todos los ranchos</option>
                        {listas.ranchos.map((rancho) => (
                            <option key={rancho.id + "rancho"} value={rancho.id}>{rancho.nombre}</option>
                        ))}
                    </select>
                </div>
                <div className='form-group'>
                    <label className='text-bold'>Valvulas</label>
                    <select className='form-control' name="valvula_id" value={selecciones.valvula_id} onChange={changeValue}>
                        <option value="">Todas las valvulas</option>
                        {listas.valvulas.map((valvula) => (
                            <option key={valvula.id + "valvula"} value={valvula.id}>{valvula.nombre}</option>
                        ))}
                    </select>
                </div>
                <div className='row justify-content-evenly w-100 m-0 p-0'>

                    <label className='text-bold'>Tipo de reporte</label>
                    <div className='col-lg-12 m-0 p-0'></div>
                    <div className="btn-group" role="group" aria-label="Basic example">
                        <button type="button" className={`btn btn-${visor.tipo_visualizacion === 'semana' ? 'warning text-bold' : 'light border shadow'}`} onClick={() => ajusteVisor('tipo_visualizacion', 'semana')}>Semana</button>
                        <button type="button" className={`btn btn-${visor.tipo_visualizacion === 'bloque' ? 'warning text-bold' : 'light border shadow'}`} onClick={() => ajusteVisor('tipo_visualizacion', 'bloque')}>Bloque</button>
                    </div>
                </div>
            </div>
            <div className='row justify-content-evenly w-100 m-0 p-0'>
                <div className='col-lg-12 m-0 p-0' style={{ maxWidth: "1500px", width: "100%" }}>
                    {visor.tipo_visualizacion === 'semana' && <TablaEjecucionSemana datos={reporte} />}
                    {visor.tipo_visualizacion === 'bloque' && <TablaEjecucionBloque datos={reporte} />}
                </div>
            </div>
        </div>
    )
    return (<div className='h1 text-center p-5'>RPT ejecucion trasplante</div>)
}

export default Rpt_ejecucion_trasplante;